<template>
    <span>
        <span class="badge badge-light ml-3" v-if="marcacao.unidade_operacao && marcacao.unidade_operacao.st_sigla">
            {{ marcacao.unidade_operacao.st_sigla }}
        </span>

        <span v-if="marcacao.fl_tele_atendimento" class="text-muted ml-3">
            <i class="fas fa-satellite-dish"></i>
        </span>

        <span class="text-muted ml-3" v-if="marcacao.item_status.ultima_etapa && marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7">
            <span v-if="tem_arquivo(marcacao)">
            <i class="fa fa-paperclip mr-2"></i>
            </span>
            <span v-if="tem_receita(marcacao)">
            <i class="fas fa-prescription mr-2"></i>
            </span>
            <span v-if="tem_requisicao(marcacao)">
            <i class="fas fa-heartbeat mr-2"></i>
            </span>
            <span v-if="tem_atestado(marcacao)">
            <i class="fa fa-plus mr-2"></i>
            </span>
        </span>

        <span v-if="marcacao.item_status.valor == 'concluido'" title="Atendimento não finalizado" class="ml-3">
            <i class="fa-solid fa-circle-half-stroke"></i>
        </span>
    </span>
</template>

<script>
export default {
    props: ['marcacao'],

    methods: { 
        tem_receita (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.receita && item.anamnese.receita.length) ? true : false;
        },

        tem_requisicao (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.requisicao && item.anamnese.requisicao.length) ? true : false;
        },

        tem_arquivo (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.arquivos && item.anamnese.arquivos.length) ? true : false;
        },

        tem_atestado (marcacao) { 
            return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.atestados && item.anamnese.atestados.length) ? true : false;
        },
    }
}
</script>